const fileTypeName = (state) => {
  const typeName = {
    'application/pdf': 'DocGo',
    'image/jpg': 'Imagem',
    'image/png': 'Imagem',
    'audio/mpeg': 'Áudio',
    'application/mp3': 'Áudio',
    'application/shp': 'Shapefile',
    'application/kml': 'KML',
  };
  return typeName[state];
};

export default fileTypeName;



// WEBPACK FOOTER //
// ./src/mixins/file-type-name.js